import React from 'react';

const CSS = `
  @keyframes rotateOrbit {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }

  @keyframes pulseCenterGlow {
    0%, 100% { transform: scale(1); opacity: 0.5; }
    50% { transform: scale(1.5); opacity: 1; }
  }

  @keyframes pulseDot {
    0%, 100% { transform: scale(1); opacity: 0.5; }
    50% { transform: scale(1.5); opacity: 1; box-shadow: 0 0 10px rgba(255, 203, 43, 0.8); }
  }
`;

function Spinner() {
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(5, 16, 33, 0.75)', // Deep navy matching GateGuide design
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center',
      zIndex: 9999,
      transition: 'opacity 0.3s ease'
    }}>
      <style>{CSS}</style>

      {/* Animation Container */}
      <div style={{ position: 'relative', width: 120, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        
        {/* Glow in the center */}
        <div style={{
          position: 'absolute',
          width: 60, height: 60,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(102,178,255,0.2) 0%, transparent 70%)',
          animation: 'pulseCenterGlow 2s ease-in-out infinite'
        }} />

        {/* Orbit Rings */}
        <div style={{
          position: 'absolute',
          width: '100%', height: '100%',
          border: '1px solid rgba(102,178,255,0.15)',
          borderRadius: '50%'
        }} />
        <div style={{
          position: 'absolute',
          width: '60%', height: '60%',
          border: '1px solid rgba(102,178,255,0.1)',
          borderRadius: '50%'
        }} />

        {/* Orbiting Airplane (Rotates around center) */}
        <div style={{
          position: 'absolute',
          width: '100%', height: '100%',
          animation: 'rotateOrbit 3s linear infinite'
        }}>
          <div style={{
            position: 'absolute',
            top: '0%', left: '50%',
            transform: 'translate(-50%, -50%) rotate(90deg)',
            filter: 'drop-shadow(0 0 6px rgba(102,178,255,0.4))'
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="#66B2FF" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Loading Text */}
      <div style={{
        marginTop: 24,
        display: 'flex', alignItems: 'center', gap: 10,
        fontFamily: "'Space Grotesk', sans-serif"
      }}>
        <div style={{
          width: 8, height: 8, borderRadius: '50%',
          background: '#FFCB2B',
          animation: 'pulseDot 1.5s infinite ease-in-out'
        }} />
        <span style={{
          color: '#E8EEFF',
          fontSize: 15, fontWeight: 600,
          letterSpacing: '1.5px',
          textTransform: 'uppercase'
        }}>
          Loading...
        </span>
      </div>
    </div>
  );
}

export default Spinner;
